class CustomJersey {
  constructor({previewCanvas, canvaName, canvaNumber},canvg){
    this.canvas = previewCanvas
    this.canvasName = canvaName
    this.canvasNumber = canvaNumber
    this.canvg = canvg
  }
  
  responsiveCanvas(){
    if(window.innerWidth > 1200) {
      this.canvas.width = 512
      this.canvas.height = 700
    } else {
      this.canvas.width = 300
      this.canvas.height = 400
    }
  }
  
  initializeContext(contextId){
    this.ctx = this.canvas.getContext(contextId)
    this.numberCtx = this.canvasNumber.getContext(contextId)
    this.nameCtx = this.canvasName.getContext(contextId)
  }

  initializeMask(src = null){
    if (src == null || src == '') return 
    this.imgMask = new Image()
    this.imgMask.crossOrigin = "anonymous";
    this.imgMask.src = src
  }
  
  sendToCanvas(ob){
    let top = 0
    let top2 = 0
    if (window.innerWidth > 1200) {
      top = 375
      top2 = 190;
    } else {
      top = 240
      top2 = 90;
    }
    
    const img = new Image()
    img.crossOrigin = "anonymous";
    img.onload = async () => {

      try {

        this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height)
        const name = await this.canvg.from(this.nameCtx, ob.svgCode.name)
        const number = await this.canvg.from(this.numberCtx, ob.svgCode.number)
        name.render()
        number.render()
        this.ctx.drawImage(this.canvasName, ob.nameX, ob.nameY)

        this.ctx.drawImage(this.canvasNumber, ob.numberX, ob.numberY)

        if (ob.hasMask) {
          this.ctx.drawImage(this.imgMask, 0, 0, this.canvas.width, this.canvas.height)
        }

 
      } catch (e) {
        console.error(e)
      }

    };

    img.src = ob.image;
    return img;
  }
  
  toUrl(){
    return this.canvas.toDataURL()
  }
}
